import React from "react";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./App";
import {Provider} from "react-redux";
import store from "./store";
import axios from "axios";
import {getToken} from "./_helpers/commonFunctions";
import {StorageController} from "./_helpers/storage-controller";
import {TranslationProvider} from "./hooks/useTranslation";

axios.interceptors.request.use(
    (request) => {
        const token = getToken();
        if (token) {
            request.headers['Authorization'] = 'Bearer ' + token
        }
        const company = localStorage.getItem("company");
        if (company) {
            request.headers["Company"] = btoa(encodeURIComponent(company));
        }
        return request
    },
    (error) => {
        Promise.reject(error)
    }
)

axios.interceptors.response.use(
    (response) => {
        if(response && response.data && response.data.status === "401") {
            localStorage.clear();
            const logoutMessage = "Η συνεδρία σας έχει λήξει."
            window.location.replace(`${process.env.REACT_APP_LOGIN_URL}?redirect=ERP&error=${logoutMessage}`);
        } else if (response && response.data && response.data.status === "503") {
            if (StorageController.getKey("maintenanceMode") === false) {
                alert("Το ERP βρίσκεται υπό αναβάθμιση, παρακαλώ ανανεώστε σε λίγο την σελίδα σας.");
                StorageController.setKey("maintenanceMode", true);
            }
            console.log("Το ERP είναι υπό αναβάθμιση, παρακαλώ δοκιμάστε πάλι σε λίγο.");
            return response;
        } else {
            if (StorageController.getKey("maintenanceMode") === true) {
                StorageController.setKey("maintenanceMode", false);
            }
            return response;
        }
        /*if (response && response.status === 502) {
            window.location.reload();
        }*/
    }
)

const container = document.getElementById("root");
container.addEventListener('copy', (e) => {
    const selection = document.getSelection();
    if (!selection) return;

    const text = String(selection).trim(); // Trim the copied string
    e.clipboardData.setData('text/plain', text);
    e.preventDefault(); // Prevent default copy to override with our trimmed version
});

const root = createRoot(container);
root.render(
    <Provider store={store}>
        <TranslationProvider defaultLocale={"el"}>
            <App />
        </TranslationProvider>
    </Provider>
)
